import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";

/** 
*@class RoomAmenity
*@property {string} icon
*@property {number} id
*@property {string} title
*@property {string} title_ar
*@property {string} status
*/

export class RoomAmenity extends TranslatableModel {
    static get translatableAttributes() {
                return [ 'title' ];
            }
    static get validationModel() {
        
                return {
                    title: {
                        label: 'AMENITY_NAME_IN_ENGLISH',
                        commonLabel: 'Amenity Name',
                    },
                    title_ar: {
                        label: 'AMENITY_NAME_IN_ARABIC',
                        commonLabel: 'Amenity Name',
                    },
                    image: {
                        label: 'AMENITY_IMAGE',
                        commonLabel: 'Amenity image',
                    }
                };
            }
}
AccessorsMutatorsDecorator('id', ...RoomAmenity.translatableAttributesWithLanguageAliases,'image','image_file', 'status')(RoomAmenity);


// WEBPACK FOOTER //
// ./src/pms-api/models/room-amenity.model.js